import { LoadingIcon as LoadingDs } from "@packages/ds";
import styled from "styled-components";

const TOTALS_COLUMN_SIZES = `
  min-width: 50px;
  max-width: 20%;
`;

const breakpoints = [
  "32rem", // 512
  "48rem", // 768
  "64rem", // 1024
  "80rem", // 1280
  "96rem", // 1536
  "112rem", // 1792
  "128rem" // 2048
];

export const OrderDetailSS = styled.div`
  box-sizing: border-box;
  width: 100%;
  border-radius: 8px;
  background-color: var(--section-snow-background-color, var(--snow));
`;

export const OrderTotalsContainerSS = styled.section`
  margin: 0;
  padding: 0;
  font-size: 15px;
`;

export const OrderPreTotalSS = styled.ul`
  margin: 0;
  padding: 0;
  color: var(--section-slate-color, var(--slate));
  background-color: var(--section-snow-background-color, var(--snow));
`;

export const OrderPreTotalItemSS = styled.li`
  display: flex;
  justify-content: space-between;
  list-style: none;
  padding: 16px 0;
  margin: 0 32px;
  border-bottom: 1px solid;
  border-bottom-color: var(
    --section-periwinkle-grey-border-bottom-color,
    var(--periwinkle-grey)
  );

  &:last-child {
    border-bottom: none;
  }
`;

export const OrderPreTotalLabelSS = styled.span`
  flex-grow: 1;
`;

export const OrderPreTotalCurrencySS = styled.span`
  ${TOTALS_COLUMN_SIZES};
  text-align: right;
  flex-grow: 1;
  margin-right: 0.5rem;
  font-weight: 700;
  color: var(--section-ebony-color, var(--ebony));

  @media (min-width: ${breakpoints[1]}) {
    margin-right: 4.5rem;
  }
`;

export const OrderTotalSS = styled.div`
  width: calc(100% - 64px);
  padding: 16px 8px;
  margin-left: 24px;
  margin-right: 24px;
  background-color: var(
    --section-color-primary-100-background-color,
    var(--color-primary-100)
  );
  display: flex;
  flex-wrap: wrap;
  border-radius: 8px;
`;

export const OrderTotalLabelSS = styled.span`
  font-weight: 700;
  flex-grow: 1;
`;

export const OrderTotalAmountSS = styled.span`
  ${TOTALS_COLUMN_SIZES};
  margin-right: 0.5rem;
  text-align: right;
  font-weight: 700;

  @media (min-width: ${breakpoints[1]}) {
    margin-right: 4.5rem;
  }
`;

export const OrderTotalInfoSS = styled.span`
  width: 100%;
  order: 2;
  color: var(--section-slate-color, var(--slate));
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  margin-top: 16px;
  margin-right: 48px;

  @media (min-width: ${breakpoints[2]}) {
    order: 0;
    width: auto;
    margin-top: 0;
  }
`;

export const OrderInfoSS = styled.footer`
  padding: 48px 36px;
  border-radius: 8px;
  background-color: var(--section-snow-background-color, var(--snow));

  @media (min-width: ${breakpoints[2]}) {
    display: flex;
    flex-wrap: wrap;
  }
`;

export const OrderInfoBlockSS = styled.div`
  @media (min-width: ${breakpoints[2]}) {
    min-width: 360px;
    flex-grow: 1;
  }
`;

export const OrderInfoHeaderSS = styled.h4`
  margin: 0;
  margin-bottom: 4px;
  font-size: 15px;
  font-weight: 700;
`;

export const OrderInfoLineSS = styled.div`
  font-size: 15px;
  line-height: 20px;
  font-weight: 400;
  color: var(--section-ebony-light-color, var(--ebony-light));
`;

export const Loading = styled(LoadingDs)`
  margin: 55px 0 5px 5px;
`;
